import { useCosInfo } from "@/controllers/gridManager/accountsManager/accountManager";
import { getCopierInfo, getHistoryCalculationFee } from "@/controllers/gridManager/followerTransManager/followerTransManager";
import TableUIElement, { Column } from "@/views/components/componentsUI/TableUIElement";
import SelectElement, { ItemOption } from "@/views/elements/select/SelectElement";
import { SelectChangeEvent } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {}

export default function CalculationFeeHistory({ }: Props) {
    const { t } = useTranslation()
    const { cosInfo } = useCosInfo()
    const { refaccount } = cosInfo
    const [listCopied, setListCopied] = useState<any[]>([])
    const [currentMasterAccount, setCurrentMasterAccount] = useState<string>('')
    const [currentStatus, setCurrentStatus] = useState<string>('')

    const columns: Column[] = [
        { id: 'fullname', label: t("copytrade.common.masterTrader"), enableSort: true },
        { id: 'start_date', label: t("copytrade.followerHistoryTransactions.bDate"), alignCell: 'center', align: 'center' },
        { id: 'ondate', label: t("copytrade.followerHistoryTransactions.onDate") },
        { id: 'payment_date', label: t("copytrade.followerHistoryTransactions.payDate"), enableSort: true, alignCell: 'right', align: 'right' },
        { id: 'mngfeeamt', label: t("copytrade.followerHistoryTransactions.managerFee"), formatNumber: true, enableSort: true, alignCell: 'right', align: 'right' },
        { id: 'bonusfeeamt', label: t("copytrade.followerHistoryTransactions.overFee"), formatNumber: true, enableSort: true, alignCell: 'right', align: 'right' },
        { id: 'a1', label: t("copytrade.followerHistoryTransactions.allFee"), cellFormula: (`mngfeeamt+bonusfeeamt`), formatNumber: true, enableSort: true, alignCell: 'right', align: 'right' },
        { id: 'paid_amt', label: t("copytrade.followerHistoryTransactions.allFeePaid"), formatNumber: true, enableSort: true, alignCell: 'right', align: 'right' },
        { id: 'a2', label: t("copytrade.followerHistoryTransactions.remainingFee"), cellFormula: ('mngfeeamt+bonusfeeamt-paid_amt'), formatNumber: true, enableSort: true, alignCell: 'right', align: 'right' },
    ];

    const ListStatus = [
        { label: 'UNPAID', value: "UNPAID" },
        { label: 'PARTLY_PAID', value: "PARTLY_PAID" },
        { label: 'PAID', value: "PAID" },
        { label: 'PENDING', value: "PENDING" },
        { label: 'ALL', value: "ALL" },
    ]

    const objParameterFn: Partial<Parameters<typeof getHistoryCalculationFee>[0]> = {
        accountId: refaccount,
        masterAccount: currentMasterAccount ?? '',
        status: currentStatus ?? 'ALL'
    }

    useEffect(() => {
        // hardcode
        async function callApiCopierInfo(accountId: string) {
            const { isSuccess, data } = await getCopierInfo({
                accountId: accountId
                , masterAccount: '' // get all
            })
            if (isSuccess) {
                const listForOption: [] = data.map((item: any): Partial<ItemOption> => {
                    return {
                        label: item?.fullname ?? '',
                        value: item?.mtacctno ?? '',
                        ...item
                    }
                })
                const ALL: any[] = []// [{ label: 'ALL', value: '' }]
                setListCopied([...ALL, ...listForOption])
            }
        }

        if (refaccount) {
            callApiCopierInfo(refaccount)
        }
    }, [refaccount])

    const handleChangeCurrentMasterAccount = (event: SelectChangeEvent<any>) => {
        const value = event.target.value ?? ''
        setCurrentMasterAccount(value);
    };

    const handleChangeStatus = (event: SelectChangeEvent<any>) => {
        const value = event.target.value ?? ''
        setCurrentStatus(value);
    };

    const renderQuery = () => {
        return <>
            <SelectElement
                placeholder='eMaster Trader'
                listItems={listCopied}
                value={currentMasterAccount}
                onChange={handleChangeCurrentMasterAccount}
            />

            <SelectElement
                placeholder={t('copytrade.common.status')}
                listItems={ListStatus}
                value={currentStatus}
                onChange={handleChangeStatus} />
        </>
    }

    return (
        <TableUIElement
            columns={columns}
            fnCallApi={getHistoryCalculationFee}
            objParameterFn={objParameterFn}
            enableDatePicker={true}
            queryBeforeDate={renderQuery}
            listenerQuery={{ currentMasterAccount, currentStatus }}
        />
    )
}